// Copyright (c) Docugami, Inc. All rights reserved.

import { DefaultButton, FluentTheme, IButtonProps, Modal, PrimaryButton, ThemeProvider } from "@fluentui/react";
import { PropsWithChildren } from "react";
import styled from "styled-components";
import { graphPickerClassNames } from "./GraphStyles";

const CommandContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    gap: 10px;
    margin-top: auto;
`;

interface StorageProviderPickerModalProps {
    isOpen: boolean;
}

export const StorageProviderPickerModal = (props: PropsWithChildren<StorageProviderPickerModalProps>): JSX.Element => {
    return (
        <ThemeProvider theme={FluentTheme}>
            <Modal isBlocking={true} isOpen={props.isOpen} scrollableContentClassName={graphPickerClassNames.modalScrollableContent} containerClassName={graphPickerClassNames.modalRoot} >
                {props.children}
            </Modal>
        </ThemeProvider>
    );
}

interface StorageProviderPickerCommandsProps {
    primaryAction: IButtonProps;
    secondaryAction?: IButtonProps;
}

export const StorageProviderPickerCommands = (props: StorageProviderPickerCommandsProps): JSX.Element => {
    return (
        <CommandContainer>
            {!!props.secondaryAction && <DefaultButton {...props.secondaryAction}>{props.secondaryAction.label}</DefaultButton>}
            <PrimaryButton {...props.primaryAction}>{props.primaryAction.label}</PrimaryButton>
        </CommandContainer>
    );
}